<template>
  <div class="param-copy-container">
    <!-- 操作按钮 -->
    <div class="copy-buttons ">
      <Button type="primary" icon="md-download" :disabled="!sourceDevice || selectedItems.length === 0"
        @click="handleCopyParams" class="copy-button">
        {{ getTranslation("b059") }}
      </Button>
    </div>
    <Row type="flex" class="device-selection">
      <!-- 源设备选择 -->
      <Col flex="1">
      <Card class="source-device-card" dis-hover>
        <template #title>
          <div class="card-title">
            <Icon type="ios-copy" />
            <span>{{ getTranslation('b057') }}</span>
          </div>
        </template>
        <div class="device-selector">
          <Select :filterable="true" :transfer="true" v-model="sourceDevice" :placeholder="getTranslation('m034')"
            :not-found-text="getTranslation('b038')" size="small" class="device-select">
            <Option v-for="item in macList" :value="item.id" :key="item.id" :label="item.code">{{ item.code }}</Option>
          </Select>
        </div>
      </Card>
      </Col>

      <!-- 目标设备选择 -->
      <Col flex="1">
      <Card class="target-device-card" dis-hover>
        <template #title>
          <div class="card-title">
            <Icon type="ios-list" />
            <span>{{ getTranslation('b058') }}</span>
          </div>
        </template>
        <div class="target-devices">
          <div class="select-all-section">
            <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll"
              size="default">
              <span>{{ getTranslation('b056') }}</span>
            </Checkbox>
          </div>

          <div class="devices-list">
            <CheckboxGroup v-model="selectedItems">
              <Row type="flex" v-for="item in macList" :key="item.id">
                <Col flex="1" class="device-checkbox-col">
                <div class="device-checkbox-item">
                  <Checkbox :label="item.id" :disabled="item.id === sourceDevice" class="device-checkbox">
                    <span :class="{ 'disabled-text': item.id === sourceDevice }">
                      {{ item.code }}
                    </span>
                  </Checkbox>
                </div>
                </Col>
              </Row>
            </CheckboxGroup>
          </div>
        </div>
      </Card>
      </Col>
    </Row>


  </div>
</template>

<script>
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { postJsError } from '@/util/util.js'
import {
  Button,
  Select,
  Option,
  Row,
  Col,
  Checkbox,
  CheckboxGroup,
  Card,
  Icon,


} from 'view-design';
import { mapGetters } from 'vuex';
export default {
  name: 'ParamCopy',
  components: {
    Button,
    Select,
    Option,
    Row,
    Col,
    Checkbox,
    CheckboxGroup,
    Card,
    Icon,

  },
  props: {

  },
  data() {
    return {
      macList: [],
      selectedItems: [],
      checkAll: false,
      indeterminate: false,
      sourceDevice: null
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
  },
  watch: {

  },
  created() {
    this.init();
  },
  mounted() {


  },
  methods: {
    init() {
      this.getData();
    },
    getData() {
      let url = API_URL["libraryInit"];
      let params = {
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.macList = res.data.data.macList;
            if (this.macList.length > 0) {
              this.sourceDevice = this.macList[0].id
            }
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('m041'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      if (this.checkAll) {
        // 排除源设备
        this.selectedItems = this.macList
          .filter(item => item.id !== this.sourceDevice)
          .map(item => item.id);
      } else {
        this.selectedItems = [];
      }
    },

    getDeviceName(deviceId) {
      const device = this.macList.find(item => item.id === deviceId);
      return device ? device.code : '';
    },

    handleCopyParams() {
      if (!this.sourceDevice || this.selectedItems.length === 0) {
        this.$Message.warning(this.getTranslation('b134'));
        return;
      }

      this.$Modal.confirm({
        title: this.getTranslation('b135'),
        okText: this.getTranslation('b181'),
        cancelText: this.getTranslation('b182'),
        content: this.getTranslation('b137') + this.getDeviceName(this.sourceDevice) + this.getTranslation('b138'),
        onOk: () => {
          let url = API_URL["libraryCopyPost"];
          let formData = new FormData();
          formData.append('mac', this.sourceDevice);
          formData.append('items', this.selectedItems.join(','));
          axios.post(url,
            formData
          )
            .then(res => {
              if (res && res.data && res.data.code == 200) {
                this.$Message.success(res.data.msg);
              } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
              } else {
                this.$Message.error(this.getTranslation('c001'));
              }
            })
            .catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            })
        }
      });
    },

  }
}
</script>

<style scoped>
.param-copy-container {
  padding: 20px;
  margin: 0 auto;
}

.device-selection {
  margin-bottom: 24px;
  width: 100%
}

.source-device-card,
.target-device-card {
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-title i {
  font-size: 18px;
  color: #2d8cf0;
}

.device-selector {
  padding: 16px 0;
}

.device-select {
  width: 100%;
  margin-bottom: 12px;
}

.target-devices {
  padding: 16px 0;
}

.select-all-section {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8eaec;
}



.devices-list {
  margin-bottom: 16px;
}

.device-checkbox-col {
  margin-bottom: 12px;
}

.device-checkbox-item {
  display: flex;
  align-items: center;
}

.device-checkbox {
  width: 100%;
}

.device-checkbox :deep(.ivu-checkbox) {
  margin-right: 8px;
}

.disabled-text {
  color: #c5c8ce;
  cursor: not-allowed;
}

.copy-buttons {
  text-align: center;
  margin: 10px 0;
}

.copy-button {
  margin-right: 12px;
  min-width: 160px;
  height: 30px;
  font-size: 14px;
}
</style>